import { defaultGunActionState } from '../gunaction_generated';

export function init_state_from_game() {
  return Object.assign({}, defaultGunActionState);
}
